import { useState } from "react";
import type { FailArticle } from "@/mocks/articles";

export default function ReactionBlock({ items }: { items: FailArticle["reactions"] }) {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  return (
    <section aria-labelledby="reaction-title" className="w-full">
      <h2 id="reaction-title" className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 flex items-center gap-2">
        <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
          <i className="ri-chat-smile-2-line"></i>
        </span>
        网友热评
      </h2>
      <p className="text-sm text-foreground-600 mb-6">
        以下为编辑整理的公开评论摘要，仅代表网友个人观点。
      </p>

      <ul className="space-y-3">
        {items.map((item, index) => (
          <li
            key={item.user}
            className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200"
          >
            <span className="w-9 h-9 shrink-0 rounded-full bg-secondary-200 text-secondary-900 flex items-center justify-center text-sm font-semibold">
              {item.user.slice(0, 1)}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-foreground-500">{item.user}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{item.text}</p>
            </div>
            <button
              type="button"
              onClick={() => setLiked((prev) => ({ ...prev, [index]: !prev[index] }))}
              aria-pressed={Boolean(liked[index])}
              className={`shrink-0 inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-full border transition-colors cursor-pointer ${
                liked[index]
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "border-background-300 text-foreground-500 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              <i className={liked[index] ? "ri-heart-fill" : "ri-heart-line"}></i>
              {item.likes + (liked[index] ? 1 : 0)}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}